export {
  VehicleDynamicWireframe,
  type VehicleDynamicWireframeProps,
} from './VehicleDynamicWireframe';
